export class Country {
    constructor
        (public text: string,
            public value: string) { }
}